import React from 'react';

/**
 * AmmoBulletsIcon
 * Custom "3 bullets side by side" icon matching Lucide stroke style:
 * - stroke-width 2, no fill, rounded caps.
 * - Sized via className tokens like w-5 h-5, colored via currentColor.
 */
const AmmoBulletsIcon = ({ className = 'w-5 h-5', strokeWidth = 2 }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* Three bullets side by side: rounded tip on top, casing rectangle below */}
    {/* Bullet 1 */}
    <path d="M4 8 Q4 5 5.5 5 Q7 5 7 8" />
    <line x1="4" y1="8" x2="7" y2="8" />
    <rect x="4" y="8" width="3" height="11" rx="0.5" />
    <line x1="4" y1="14" x2="7" y2="14" />
    {/* Bullet 2 */}
    <path d="M10.5 8 Q10.5 5 12 5 Q13.5 5 13.5 8" />
    <line x1="10.5" y1="8" x2="13.5" y2="8" />
    <rect x="10.5" y="8" width="3" height="11" rx="0.5" />
    <line x1="10.5" y1="14" x2="13.5" y2="14" />
    {/* Bullet 3 */}
    <path d="M17 8 Q17 5 18.5 5 Q20 5 20 8" />
    <line x1="17" y1="8" x2="20" y2="8" />
    <rect x="17" y="8" width="3" height="11" rx="0.5" />
    <line x1="17" y1="14" x2="20" y2="14" />
  </svg>
);

export default AmmoBulletsIcon;
